// // Import the functions you need from the SDKs you need
// import firebase from 'firebase/compat/app'
// import 'firebase/compat/firestore'
// import 'firebase/compat/storage'
// let firebaseApp;
// setUp()

// function setUp() {
//     const firebaseConfig = {
//         apiKey: process.env.API_KEY,
//         authDomain: process.env.AUTH_DOMAIN,
//         projectId: process.env.PROJECTID,
//         storageBucket: process.env.STORAGE,
//         messagingSenderId: process.env.MESSAGINGSENDER,
//         appId: process.env.APPID,
//         measurementId: process.env.MEASUREMENT
//     };
//     firebaseApp = firebase.initializeApp(firebaseConfig);
// }
// export default firebaseApp;

// Import the functions you need from the SDKs you need
import firebase from 'firebase/compat/app'
import 'firebase/compat/firestore'
import 'firebase/compat/storage'
let firebaseApp;
setUp()

function setUp() {
    const firebaseConfig = {
        apiKey: "AIzaSyBP3Dfo7jEXMIcl5EQ7MsyA9YBF_VUoqws",
        authDomain: "hamster-kombat-clone-dab00.firebaseapp.com",
        projectId: "hamster-kombat-clone-dab00",
        storageBucket: "hamster-kombat-clone-dab00.appspot.com",
        messagingSenderId: "401640673927",
        appId: "1:401640673927:web:9687f5fac7d88df8081e22",
        measurementId: "G-2NYYM00X9L"
    };
    firebaseApp = firebase.initializeApp(firebaseConfig);
}
export default firebaseApp;